import React from 'react';

export function SoundWaveAvatar({ isAnimating = false, size = 32 }) {
  const barCount = 5;
  const barWidth = 3;
  const gap = 2;
  const maxHeight = size * 0.7;
  const totalWidth = barCount * barWidth + (barCount - 1) * gap;
  const offsetX = (size - totalWidth) / 2;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className="shrink-0"
      data-testid="sound-wave-avatar"
    >
      <circle cx={size / 2} cy={size / 2} r={size / 2} fill="#10B981" opacity="0.15" />
      {Array.from({ length: barCount }).map((_, i) => {
        const baseHeight = [0.4, 0.7, 1, 0.7, 0.4][i] * maxHeight * 0.5;
        const x = offsetX + i * (barWidth + gap);
        const y = (size - baseHeight) / 2;

        return (
          <rect
            key={i}
            x={x}
            y={y}
            width={barWidth}
            height={baseHeight}
            rx={1.5}
            fill="#10B981"
            className={isAnimating ? 'sound-bar-animate' : ''}
            style={{
              transformOrigin: `${x + barWidth / 2}px ${size / 2}px`,
              animationDelay: isAnimating ? `${i * 0.12}s` : '0s',
            }}
          />
        );
      })}
    </svg>
  );
}
